module.exports = __webpack_public_path__ + "static/media/startup-icon@3x.db8f6021.png";